import type { ReadonlyDeep } from 'type-fest';

import { QuotationHeaderInput } from '@e-socna/data-layer';

import { pruneInput } from '../../../utils/prune-input.util';

import type { QuotationHeaderForm_QuotationHeader } from '../../QuotationHeader/fragments/quotation-header.fragment';

export function quotationHeaderForm2ApiMapper(
  quotationHeader: ReadonlyDeep<QuotationHeaderForm_QuotationHeader>,
): ReadonlyDeep<QuotationHeaderInput> {
  const quotationHeaderInput = pruneInput(
    quotationHeader,
    QuotationHeaderInput,
  );

  return {
    ...quotationHeaderInput,
    // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
    interventionDate: quotationHeaderInput.interventionDate || null,
    // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
    modalities: quotationHeaderInput.modalities || null,
    // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
    note: quotationHeaderInput.note || null,
  };
}
